import { TWIN_PIGMENTS } from "../motion/particle-geometry";

export { TWIN_PIGMENTS };
const noise = (seed: number) => {
  const n = Math.sin(seed * 127.1 + 311.7) * 43758.5453;
  return n - Math.floor(n);
};
const dot = (x: number, y: number, r: number) =>
  `M${(x - r).toFixed(1)} ${y.toFixed(1)}a${r.toFixed(1)} ${r.toFixed(1)} 0 1 0 ${(2 * r).toFixed(1)} 0a${r.toFixed(1)} ${r.toFixed(1)} 0 1 0 ${(-2 * r).toFixed(1)} 0`;

// Matching path commands let the same evidence move between each composition.
export const STORY_LAYERS = TWIN_PIGMENTS.map((color, layer) => {
  let scattered = "", held = "", answer = "";
  const count = Math.max(130, Math.round((205 - layer * 34) * 3.2));
  for (let i = 0; i < count; i++) {
    const seed = layer * 419 + i;
    const angle = i / count * Math.PI * 2;
    const radius = 205 - layer * 34 + (noise(seed) - .5) * 19;
    const x = Math.cos(angle) * radius, y = Math.sin(angle) * radius;
    const size = 1.4 + noise(seed + 4) * 1.5;
    held += dot(500 + x, 300 + y, size);
    answer += dot(265 + x * .8, 300 + y * .8, size);
    scattered += dot(100 + noise(seed + 9) * 800, 85 + noise(seed + 18) * 430, size);
  }
  return { color, scattered, held, answer };
});

export const LAYER_STORIES = [
  { title: "Sources", note: "Start with the systems your business already uses.", example: "Documents · messages · business systems" },
  { title: "Records", note: "Give scattered information a common structure.", example: "Customers · projects · invoices" },
  { title: "Relationships", note: "Understand how the parts of your business connect.", example: "A customer, their work and what they owe" },
  { title: "Definitions", note: "Use the meaning your business has agreed on.", example: "What counts as overdue? What counts as revenue?" },
  { title: "Evidence", note: "Keep the source behind each fact within reach.", example: "Where it came from · when it changed" },
  { title: "Answers", note: "Put that shared understanding to work.", example: "Ask a question. Follow the answer back." },
];
